const english = {
  addressInput: {
    errorMessage: 'Select an address from the list of suggestions or <i>enter manually</i>.',
    manualModeButton: 'Enter address manually',
    placeholder: 'Enter a location',
  },

  date: {
    today: 'Today',
    tomorrow: 'Tomorrow',
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    months: 'January, February, March, April, May, June, July, August, September, October, November, December',
    weekdays: 'Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday',
    weekdaysShort: 'S, M, T, W, T, F, S',
  },

  dateFormat: {
    medium: 'MMMM DD YYYY',
    long: 'dddd, MMMM Do YYYY',
  },

  dateTimeFormat: {
    long: 'dddd, MMMM Do h:mm A',
  },

  linkTitle: 'Navigate to "{name}" event',

  navigateBack: 'Back',

  formInput: {
    optional: 'optional',
  },

  giftAidCheckbox: {
    heading: 'Gift Aid your order',
    description: 'Support Ticketure by choosing to Gift Aid your order at <strong>no extra cost to you.</strong>',
  },

  homeRoute: {
    title: 'Welcome',
    loginTitle: 'Already a member',
    signupTitle: 'Become a member',
    guestTitle: 'Continue as a guest',
    resendTicketsTitle: 'Already have tickets?',
    signupButton: 'Sign up for membership',
    guestButton: 'Buy tickets',
    resendTicketsLink: 'Resend confirmation link',
  },

  loginForm: {
    invalidCredentials: {
      scan_code: 'Member details not found. Please check your member ID and ZIP code.',
      scan_code_last_name: 'Member details not found. Please check your member ID and last name.',
      scan_code_password: 'Member details not found. Please check your email address and member ID.',
    },
    loginButton: 'Log in',
    notAMember: "Don't have a membership?",
    becomeAMember: 'Become a member',
    neverLoggedIn: 'Not logged in before?',
    createAnAccount: 'Create an account',
    forgotPassword: 'Set or reset your password here',
    forgotMembership: 'Forgot your membership ID?',
    lastNameLabel: 'Primary member last name',
    title: 'Account login',
    memberID: 'Member ID',
  },

  loginFlowStepEmail: {
    loginHelpText: 'Enter your email address to receive a one-time login link and passcode.',
    loginWithOTPButton: 'Send login link',
    buttonSeparatorText: 'or',
    loginWithPasswordButton: 'Log in with password',
    notAMember: "Don't have a membership?",
    becomeAMember: 'Become a member',
  },

  loginFlowStepPassword: {
    inputLabel: 'Enter your password',
    loginButton: 'Log in',
    backButton: 'Back',
    forgotPassword: 'Forgot your password?',
  },

  loginFlowStepOTP: {
    linkSent: 'We have sent a one-time login link and passcode to',
    linkInstructions:
      'Use the login link to automatically login into your account or enter the accompanying passcode below.',
    inputLabel: 'Enter your 6-character code',
    loginButton: 'Log in',
    backButton: 'Back',
    hasntArrived:
      'If your login link hasn’t arrived, check your spam folder or <request-code-link>send the link again</request-code-link>.',
    newLinkSent: 'A new login link has been sent.',
    invalidCode: 'The passcode you entered is invalid.',
    remainingAttempts: 'You have {count} more attempt{s} before you need to request a new login link.',
    mustRequest:
      'You need to <request-code-link>request a new login link</request-code-link> before attempting to log in with a passcode again',
  },

  loginFlowStepOTPUnavailable: {
    intro: "We've received a request for a single-use code to access your account.",
    yourPasscode: 'Your passcode is',
    instructions:
      "To continue, enter this code in the browser tab where you first requested it, or <request-code-link>request a new login link</request-code-link> if you're using a different device.",
    copyText: 'Copy',
    copiedText: 'Copied',
  },

  loginOrGuestDialog: {
    title: 'Are you a member?',
  },

  forgotMembership: {
    title: 'Forgot your membership ID?',
    sendMembershipID: 'Send membership ID',
  },

  forgotPasswordRoute: {
    title: 'Reset password',
    body: '<p>Enter the email address associated with your membership. We will send you a one-time link to reset your password.</p>',
    sendResetLink: 'Send reset link',
  },

  completedOrdersRoute: {
    title: '<span>Done!</span> We look forward to your visit',
    ticketsOrderNumber: 'Your experience order number is {number}',
    membershipOrderNumber: 'Your membership order number is {number}',
    giftOrderNumber: 'Your gift order number is {number}',
    printOrder: 'View and print your tickets',
  },

  pendingOrdersRoute: {
    title: '<span>Done!</span> Your order has been received',
    referenceNumber: '<p>Reference number</p> {number}',
    message:
      '<p>Once your initial debit payment has been successfully cleared with your bank, you will receive an email confirming the completion of your order and the activation of your membership.</p>',
  },

  eventListingRoute: {
    title: 'Choose your events',
    upsellsTitle: 'What other experiences would you like to add?',
  },

  eventListingItem: {
    buttonText: 'Select',
  },

  dateFilters: {
    all: 'All dates',
  },

  categoryFilters: {
    all: 'All',
  },

  availabilityStatus: {
    soldOut: 'Sold out',
    available: 'Available',
    nAvailable: '{count} left',
    // unavailable: 'Unavailable',
  },

  reserve: {
    unavailable: 'Sorry, tickets are not available for this event.',
    unavailableOnDate: 'Sorry, tickets are not available for this event on the date of your visit.',
    sessionUnavailable: 'Sorry, tickets for this event are not available at the selected time.',
    sessionNotFound: 'Sorry, the selected time is not found.',
    ticketTypesNotFound:
      'Sorry, the selected ticket type is not available. | Sorry, the selected ticket types are not available.',
    title: 'Select tickets',
    buttonLabel: {
      default: 'Add to cart',
      tickets: 'Add tickets to cart | Add 1 ticket to cart | Add {count} tickets to cart',
      passes: 'Add passes to cart | Add 1 pass to cart | Add {count} passes to cart',
      donation: 'Add donation to cart',
      giftcards: 'Add gift to cart',
      member: 'Add membership to cart',
    },
    ticketQuantity: '1 ticket | {count} tickets',
    skipAddOn: 'Skip add-on',
    addOnHelpText: 'You can upgrade your experience by selecting this optional add-on.',
    selectDateLabel: 'Select a date',
    selectDateDescription: 'Which day would you like to visit?',
  },

  reserveDateFirst: {
    // TODO Move `pickFlexibleTickets` and `singleDateAdmission` to `anyOrSingleDate`.
    pickFlexibleTickets: 'Any day admission',
    singleDateAdmission: 'Single date admission',
  },

  reserveQuantityFirst: {
    findAvailableTickets: 'Find available tickets',
  },

  stepperGroupTitles: {
    members: 'Select member {type}',
    guests: 'Select non-member {type}',
    default: 'Select {type}',
    giftOfMembership: 'Select memberships',
  },

  stepperGroupDescriptions: {
    default: 'Who is coming to this session?',
    giftOfMembership: 'What level of membership would you like to gift?',
    passes: 'How many passes would you like?',
  },

  admitDetailsFields: {
    title: 'Enter your details',
    label: '{ttName} {number}',
  },

  citypassCoupons: {
    enableQuestion: 'Are you redeeming CityPASS vouchers for this visit?',
    instructions: 'Please enter your CityPASS voucher numbers',
  },

  // TODO Move to .selectSession.conflictTimes.
  conflictTimes: 'These times conflict with your other tickets:',

  selectSession: {
    description: 'What time would you like to attend?',
  },

  selectAvailableSession: {
    title: 'Select a time',
  },

  tixPayment: {
    title: 'Payment details',
  },

  tixLegend: {
    priceIncludesTax: 'Prices include taxes & fees',
    priceExcludesTax: '',
  },

  accountLinks: {
    loginLinkShortLabel: 'Login',
    registerLinkShortLabel: 'Membership',
    loginLinkLongLabel: 'Account login',
    registerLinkLongLabel: 'Become a member',
  },

  survey2: {
    heading: 'We require some more information',

    labelOverrides: {
      // This allows titles to be added for specified survey questions per tenant.
      // This empty object makes accessing simpler from templates for tenants that do not use this feature.
    },
    questionTitles: {
      // This allows titles to be added for specified survey questions per tenant.
      // This empty object makes accessing simpler from templates for tenants that do not use this feature.
    },
  },

  membersOnly: {
    title: 'Sorry!',
    description: 'This event is members only',
    loginLinkLabel: 'Log in',
    signupTemplate: 'Not a member? <membership-link>Sign up</membership-link> to enjoy member exclusive events.',
  },

  membersBanner: {
    welcomeBack: 'Welcome {name}!',
  },

  namedMembers: {
    singleOptionalLabelAnother: 'I would like to name another {role_name}.',
    singleOptionalLabel: (ctx) => {
      const role = ctx.named('role_name') as string
      const article = 'aeiou'.includes(role[0]) ? 'an' : 'a'
      return `I would like to name ${article} ${role}.`
    },
    multipleOptionalLabel: 'How many {role_name} would you like to name?',
    multipleOptionalLabelMore: 'How many more {role_name} would you like to name?',
  },

  unnamedMembers: {
    label: 'Please specify the number of {role_name}.',
    countLabel: '{count} {name} member selected | {count} {name} members selected',
  },

  memberRoleLabels: {
    // TODO Add labels for more common party_roles?
    // The ticket type name is used as a fallback.
    member: 'member | members',
    'second-card': 'second card holder | second card holders',
    'third-card': 'third card holder | third card holders',
    youth: 'youth member | youth members',
    'youth-member': 'youth member | youth members',
    child: 'child member | child members',
    'child-member': 'child member | child members',
    caregiver: 'caregiver | caregivers',
    guest: 'guest | guests',
    'additional-member': 'additional member | additional members',
  },

  membership: {
    title: 'Membership',
    renewTitle: 'Renew membership',
  },

  membershipFormLabels: {
    member: {
      default: 'Your name as you would like it to appear on your membership card.',
      gift: "Recipient's name (as it should appear on the membership card).",
    },
    second_card: {
      default: 'Would you like a second membership card for another adult in your household?',
      gift: "Does a second adult residing in the recipient's household need a membership card?",
    },
    caregiver: {
      default: 'Would you like to add a primary caregiver (e.g. nanny or babysitter) to your account?',
      gift: 'Would you like to add a primary caregiver (e.g. nanny or babysitter) to the account? (if unknown, choose "no")',
    },
    children: {
      default: 'How many children under 18 are in your household?',
      gift: "How many children under 18 are in the recipient's household?",
    },
    physical_card: {
      // default: this.membershipTicketGroup.additional_info_spec.properties.physical_card.title,
      default:
        'Digital membership card(s) will arrive by email. Do you also want physical cards(s) via mail? (Takes 3-5 weeks.)',
      gift: 'Digital membership card(s) can be emailed to the recipient in a later step. Would you like a welcome package with physical membership cards(s) sent by mail? (Arrival may take 3-5 weeks and can’t be scheduled.)',
    },
  },

  giftCards: {
    smallPrintAfterForm: 'Tax-deductible membership gifts and Annual Fund donations are non-refundable.',
  },

  applyGiftCards: {
    modalTitle: 'Apply a gift card',
    applyGiftCard: 'Apply a gift card',
    applyAnotherGiftCard: 'Apply another gift card',
  },

  applyGiftCardsModal: {
    giftCardNotFound: 'Gift card not found',
    giftCardNumberLabel: 'Gift card number',
  },

  applyPromoCodes: {
    applyButtonLabel: 'Apply',
    applyPromoCodeLabel: 'Apply a promo code',
    applyAnotherPromoCodeLabel: 'Apply another promo code',
    apiErrorMessages: {
      // code_exhausted: 'Code entered has already been redeemed the maximum number of times. Please check the code and reenter.',
    },
    apiErrorMessage: '{message}.',
    defaultApiErrorMessage: '"<em>{code}</em>" is not a valid promo code.',
    unknownErrorMessage: 'Sorry. Please try again later.',
  },

  contextualEventTitles: {
    // Only force a title override for all tenants for renewal and gift of membership.
    membershipGift: 'Gift of membership',
    membershipRenew: 'Renew your membership',
  },

  selectDate: {
    tooltip: 'Select a date',
    placeholder: 'Pick a date',
    showMoreDates: 'Show more dates',
    moreThanYearAway: 'The date you selected is {date} which is more than a year away.',
  },

  ticketTypeSteppers: {
    more: 'More',
    less: 'Less',
    countLabel: '{count} {name} ticket selected | {count} {name} tickets selected',
  },

  price: {
    freePrice: 'Free',
  },

  checkoutRoute: {
    title: 'Payment information',
    yourInformation: 'Your information',
    totalOutstanding: 'Total to pay',
    memberMessage: 'Once you have completed your order, your order will be emailed to {email}.',
    ticketsEmailToMessage: 'Tickets will be emailed to <em>{email}</em> upon payment.',
    identityDataMessage: 'Your {wallet} contact details will be used for this order.',
    paymentNotSupportedWarning: 'Payment is not supported for this amount.',
  },

  identityForm: {
    requiredFieldsDescription: 'Required fields are marked with an asterisk ( <required-asterisk/> ).',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email address',
    emailConfirm: 'Confirm email address',
    password: 'Password',
    passwordConfirm: 'Confirm password',
    state: 'State',
    province: 'Province',
  },

  validationMessages: {
    emailMustMatch: 'Email addresses must match.',
    passwordMustMatch: 'Passwords must match.',
  },

  cartWidget: {
    title: 'Your cart',
    emptyCartMessage: 'You have no items in your cart.',
    subtotal: 'Subtotal',
    payments: 'Total paid',
    total: 'Cart total',
    partialTotal: 'Total to pay',
    cartBalance: 'Cart balance',
    discounts: 'Discounts',
    fixedFees: 'Service charges',
    percentFees: 'Tax',
    flowExperience: '{count} experience | {count} experiences',
    cartAddAnnouncement: '{count} item added to your cart. | {count} items added to your cart.',
  },

  mobileCartWidget: {
    moreEvents: 'More events',
  },

  expiryTimer: {
    // Use a non-breaking space to avoid line break in the countdown.
    expiresIn: 'Your cart will expire&nbsp;in <span class="time">{time}&nbsp;min</span>',
    screenReaderExpiresIn: 'Your cart will expire in {minutes} minutes and {seconds} seconds',
  },

  payButton: {
    desktop: {
      proceedButtonLabel: 'Proceed to checkout',
      completeButtonLabel: 'Complete order',
      makePayment: 'Make payment',
      completeGiftButtonLabel: 'Complete gift order',
      completeRedeemMembershipLabel: 'Redeem membership',
    },
    mobile: {
      proceedButtonLabel: 'Checkout',
      completeButtonLabel: 'Complete order',
      makePayment: 'Make payment',
      completeGiftButtonLabel: 'Complete gift order',
      completeRedeemMembershipLabel: 'Redeem membership',
    },
  },

  termsCheckbox: {
    checkboxLabel: 'Please <a>read and accept the terms & conditions</a> to proceed with your order.',
  },

  cartExpire: {
    title: 'Cart timed out',
    message: 'Unfortunately your cart has timed out.',
    buttonLabel: 'Start over',
  },

  extendCartTimerModal: {
    title: 'Would you like more time?',
    message:
      '<p>Oh no, your cart is about to time out!</p> <p>Would you like to <strong>add another 2 minutes?</strong></p>',
    dismissButtonLabel: 'No thanks',
    confirmButtonLabel: 'Add another 2 minutes',
  },

  resendOrderRoute: {
    title: 'Enter your email address to resend your tickets',
    notFound: 'No orders could be found for this email address.',
    logout: 'Log out to resend your tickets.',
    buttonLabel: 'Resend ticket email',
    completeTitle: 'Your order confirmation and tickets have been resent.',
  },

  cancelFreeOrderRoute: {
    cancelTicketsTitle: 'Cancel events and tickets',
    cancelTicketsSubtext:
      'Please check the events and/or tickets you would like to cancel for your most recent reservation. You will receive an email confirmation upon cancellation.',
    ticketName: '{typeName} ticket {index}',
    noTicketsFound: 'No valid tickets found on this order.',
    noFreeTicketsFound: 'You must contact us to cancel this order.',
    selectAllLabel: 'Select all tickets',
    cancelSelectedLabel: 'Cancel selected tickets',
    cancelOrderLabel: 'Cancel order',
    order: 'Order',
    cancelModalTitle: 'Cancel tickets',
    cancelModalSubtext:
      'Are you sure you want to cancel 1 ticket from your reservation? | Are you sure you want to cancel {count} tickets from your reservation?',
    orderCancelled: 'You have successfully cancelled your order',
    ticketsCancelled: 'You have successfully cancelled 1 ticket | You have successfully cancelled {count} tickets',
  },

  editOrderRoute: {
    noTicketsFound: 'No valid tickets found on this order.',
    ticketName: '{typeName} ticket {index}',
    cancelOrderLabel: 'Cancel order',
    orderCancelled:
      'This order has been cancelled. <router-link to="/">Click here</router-link> to purchase more tickets.',
    removeTicketTitle: 'Remove ticket',
    removeTicketMessage:
      'Are you sure you want to remove <strong>{ticketName}</strong> from the experience <strong>{eventName}</strong>?',
    removeEventTitle: 'Remove experience',
    removeEventMessage: 'Are you sure you want to remove <strong>{eventName}</strong> from your order?',
    cancelOrderTitle: 'Cancel order',
    cancelOrderMessage: 'Are you sure you want to cancel your order?',
    rescheduleSuccessMessage:
      'Your order has been successfully changed. You will receive a confirmation email soon with your new itinerary.',
    ticketCancelledSuccessMessage: 'Your ticket has been cancelled.',
    paymentNotSupportedError: 'Please contact us to reschedule your tickets.',
  },

  rescheduleRoute: {
    title: 'Reschedule experience',
    description: `Please choose a new date and time for the experience <strong>{name}</strong>,
        currently booked for <strong>{count}</strong> on <strong>{date}</strong> at <strong>{time}</strong>.`,
    costIncreaseWarning: 'The selected session time of {time} will incur an additional cost of {cost}',
  },

  stripeCreditCard: {
    creditCardLabel: 'Card details',
  },

  termsModal: {
    title: 'Terms & conditions',
  },

  membershipModal: {
    title: 'Membership details',
    noEmailMessage: 'No email on file',
    membershipNumber: 'Membership number',
    membershipLevel: 'Membership level',
    membershipExpiration: 'Membership expiration',
    renewMembershipButton: 'Renew membership',
    cancelAutoRenew: 'Cancel auto-renew',
  },

  purchasedMembership: {
    autoRenewContactMessage: 'Please contact us to enroll your membership for auto-renew.',
  },

  membershipLevel: {
    membershipLevel: 'Membership level',
    showMoreLabel: 'Show all benefits',
  },

  membershipForm: {
    title: 'Edit your membership',
    caption: 'Please edit the details of your membership',
    membershipExpiration: 'Membership expiration',
    lastMembershipLevel: 'Last membership level',
    gift: {
      title: 'Recipient details',
      caption: "Please edit the details of your recipient's membership",
    },
  },

  membersMenu: {
    membershipDetails: 'Membership details',
    myAccount: 'My account',
  },

  buyMembership: {
    reserveButton: 'Add membership to cart',
    yes: 'Yes, renew annually',
    no: 'No',
    autoRenewal: 'Auto renewal',
    autoRenewalSubtext: 'Automatically renew your membership.',
    deleteCartOrCheckout: {
      title: 'Buy membership',
      description: 'You need to take action on your current cart before you can buy another membership.',
    },
  },

  membershipRoute: {
    unavailableMessage: 'Memberships are not available at this time.',
    gifteeHeader: {
      title: 'Recipient contact information',
    },
  },

  redeemMembershipRoute: {
    queryParam: {
      title: 'Congratulations! You’ve been gifted a membership!',
      description:
        'Looks like someone really likes you! You’ve received a membership to experience great art, big ideas, and courageous conversations that can only be found here.',
    },
    input: {
      title: 'Redeem a gift of membership',
      description:
        'If you have received a gift of membership from someone, please enter the 10-digit code below to start the redemption process.',
      inputHeaderTitle: 'Gift of membership code',
      inputHeaderDescription: 'This is your unique 10-digit code',
      appliedCode: 'Applied code',
    },
    membershipLevels: {
      label: 'Choose a membership',
      description: 'The first membership is your gift, which you may upgrade at your cost if you wish',
    },
    noMembershipsMessage: 'There are no available memberships at this time. Please contact support.',
  },

  cancelAutoRenewRoute: {
    title: 'Cancel membership auto-renew',
    body: 'Are you sure you want to unenroll your membership from automatic renewal?',
    confirmUnenrollment: 'Confirm unenrollment',
    cancel: 'Cancel',
    done: 'Done',
    successful:
      'Your <strong>{level}</strong> membership is successfully unenrolled. Please continue to use your membership until {valid_to}.',
    notAuthenticatedError:
      'This membership does not appear to be enrolled in automatic renewal.<br/>Please <login-link>login</login-link> to view the details of your current membership.',
    notEnrolledError: 'This membership does not appear to be enrolled in automatic renewal.',
  },

  renewMembershipMessage: {
    expiresIn:
      'Your membership expires {expiryDate}. <membership-link renew="true">Renew now</membership-link> to reserve members-only tickets on {ticketDate}.',
    expired:
      'Your membership expired. <membership-link renew="true">Renew now</membership-link> to reserve members-only tickets on {ticketDate}.',
    expiredNoDate:
      'Your membership expired. <membership-link renew="true">Renew now</membership-link> to reserve members-only tickets.',
  },

  selectSeats: {
    findSeats: 'Find seats',
    changeSelectedSeats: 'Change selected seats',
    message: 'Please select {list}',
    singleItem: '{count} seat | {count} seats',
    listItem: '{count} {name} seat | {count} {name} seats',
  },

  codeModal: {
    title: 'A code is required',
    applyButton: 'Apply',
  },

  emailSubmitForm: {
    email: 'Email address',
  },
}

export default english
